import * as React from "react";

function SvgAttentionAlt(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 8 23.97"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M7.99 1.09l-.5 13.07a1.09 1.09 0 01-.37.77 1.15 1.15 0 01-.82.32H1.7a1.15 1.15 0 01-.82-.32 1.05 1.05 0 01-.37-.77L-.01 1.09A1 1 0 01.32.32a1.13 1.13 0 01.8-.31h5.77a1.13 1.13 0 01.8.32 1 1 0 01.3.76zm-.54 18v3.81a1 1 0 01-.34.77 1.17 1.17 0 01-.81.32H1.7a1.17 1.17 0 01-.81-.32 1 1 0 01-.34-.77v-3.83a1 1 0 01.34-.77 1.17 1.17 0 01.81-.29h4.61a1.17 1.17 0 01.81.32 1 1 0 01.34.74z" />
    </svg>
  );
}

const MemoSvgAttentionAlt = React.memo(SvgAttentionAlt);
export default MemoSvgAttentionAlt;
